import * as React from "react";
import path = require("path");
import { Tabs, Tab } from 'react-bootstrap';
import { useFormApi, useFormState } from "informedv4";
import { RenderSettingControl } from "./setting-control-renderer";
import { RenderSettingPanel } from "./setting-section-panel";
import { useMemo } from "react";

export const RenderSettings = ({ setting }) => {
    if (!setting)
        return null;

    const keys = Object.keys(setting).filter(key => key != "label" && key != "studySessionType" && key != "studyDeviceType");
    return (
        <Tabs defaultActiveKey={keys[0]} id="StudySettingsTabs" className="col-md-12">
            {keys.map(key => {
                const settingSection = setting[key];
                const sectionKeys = Object.keys(settingSection).filter(key => key != "label" && key != "studySessionType" && key != "studyDeviceType");

                if (sectionKeys.length == 0 || sectionKeys.every(key => settingSection[key]?.editable == false))
                    return null;

                const sectionPanelKeys = sectionKeys.filter(key => settingSection[key]?.valueType == undefined)
                const sectionControls = sectionKeys.filter(key => settingSection[key]?.valueType != undefined)
                return (
                    <Tab key={key} eventKey={key} title={settingSection.label} >
                        <div className="panel">
                            <div className="panel-heading">
                                <h3 className="text-primary">{settingSection.label} Settings</h3>
                            </div>
                            <>
                            {
                                sectionControls.length === 0 ? null :
                                    sectionControls.map((sectionKey, index) => {
                                        <RenderSettingControl
                                            key={`${key}-${sectionKey}`}
                                            settingDefinition={settingSection[sectionKey]}
                                            settingKey={sectionKey}
                                            parentSectionKey={key} />
                                    })
                            }
                            {
                                sectionPanelKeys.map(sectionKey => {
                                    return (<RenderSettingPanel
                                        key={`${key}-${sectionKey}`}
                                        settingSection={settingSection[sectionKey]}
                                        sectionKey={sectionKey}
                                        parentSectionKey={key} />)
                                })
                                }
                            </>
                            </div>
                   
                        </Tab>
                );
            })}
        </Tabs>
    )
}
